import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { Supplier } from "src/app/inventory/supplier/supplier";
import { SupplierService } from "src/app/inventory/supplier/supplier.service";
import { Invoice } from "src/app/purchase/invoice/invoice";
import { InvoiceService } from "src/app/purchase/invoice/invoice-service";
import { Page } from "src/app/util/page";
import { Criteria } from "src/app/util/search/criteria/criteria";
import { SearchComponent } from "src/app/util/search/search-component";
import { SearchRequest } from "src/app/util/search/search-request";
import { ReceptionInvoiceStatus } from "../../reception-invoice-status";
import { ReceptionService } from "../../reception-service";

@Component({
  styleUrls: ['./new-reception.component.css'],
  templateUrl: './new-reception.component.html',
})
export class NewReceptionComponent extends SearchComponent<Supplier> {
  public applyButtonTitle!: string;

  error = false;
  receptionInvoiceStatus!: ReceptionInvoiceStatus;
  supplier!: Supplier;
  suppplierInvoiceNumber = "";
  invoiceLoading = false;

  constructor(
    public modal: NgbActiveModal,
    private receptionService: ReceptionService,
    private router: Router,
    private supplierService: SupplierService,
  ) {
    super(new Map<string, Criteria>());

    this.refresh();
  }

  public refresh(): void {
    this.search();
  }

  public supplierSelected(supplier: Supplier) {
    this.supplier = supplier;

    this.searchInvoice();
  }

  searchInvoice() {
    if (this.supplier == undefined) {
      return;
    }

    this.error = false;
    this.invoiceLoading = true;

    this.receptionService.receptionInvoiceStatus(this.supplier.id, this.suppplierInvoiceNumber)
      .pipe(tap(receptionInvoiceStatus => this.receptionInvoiceStatus = receptionInvoiceStatus))
      .subscribe({
        complete: () => this.invoiceLoading = false,
        error: _ => this.error = true
      });
  }

  public onSearch(searchRequest: SearchRequest, page: number): Observable<Page<Supplier>> {
    return this.supplierService.findAll({
      name: searchRequest.query,
    }, page, 50);
  }

  newReception() {
    this.receptionService
      .newReception(this.supplier, this.receptionInvoiceStatus.invoiceId, this.suppplierInvoiceNumber)
      .pipe(tap(reception=>this.router.navigate(["/inventory/reception", reception.id])))
      .pipe(tap(_=>this.modal.close()))
      .subscribe({
        error: _ => {
          this.loading = false;
          this.error = true;
        }
      });
  }


}